<template>
	<div class="styled-form__field">
		<label
			class="styled-form__label"
			:for="name"
		>{{ label }}</label>

		<span
			:class="['styled-form__error', {'is-visible': error}]"
		v-html="error">{{ error }}</span>

		<input
        v-if="type === `number`"
        :class="['styled-form__input', {'is-invalid': error}]"
        :maxlength="maxLength"
        :type="type"
        :min="min"
        :max="max"
        :id="name"
        :name="name"
        :value="value"
        @input="$emit('input', $event.target.value)"
        :disabled="disabled"
        @paste="$emit('paste', $event)"
		>

    <input
        v-else
			:class="['styled-form__input', {'is-invalid': error}]"
      :maxlength="maxLength"
      :type="type"
			:id="name"
			:name="name"
			:value="value"
			@input="$emit('input', $event.target.value)"
			:disabled="disabled"
			@paste="$emit('paste', $event)"
		>
	</div>
</template>

<script>
	export default {
    model: {
      prop: 'value'
    },
    props: {
      type: {
        type: String,
        default: 'text'
      },
      min: {
        type: Number,
        default: 1
      },
      max: {
        type: Number,
        default: 8
      },
      maxLength: {
        type: Number,
      },
      name: {
        type: String,
        required: true
      },
      label: {
        type: String,
        required: true
      },
      error: {
        type: String
      },
      value: {
        type: String
      },
      disabled: {
        type: Boolean,
        default: false
      },
      autocomplete: {
        type: String,
        default: 'off'
      }
    }
  };
</script>
